export enum AddOns {
    User = "Users",
    License = "Licenses",
    Organization = "Organizations",
}